import { render, staticRenderFns } from "./DotsMenu.vue?vue&type=template&id=38a01c69&scoped=true&"
import script from "./DotsMenu.vue?vue&type=script&lang=js&"
export * from "./DotsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a01c69",
  null
  
)

export default component.exports